import React, { useState } from "react";
import DeliveryOversea from "./DeliveryOversea";
import DeliveryFee from "./DeliveryFee";
import DeliveryEstimatedDate from "./DeliveryEstimatedDate";
import DeliveryEtc from "./DeliveryEtc";
import DeliveryCombine from "./DeliveryCombine";
import PopupLayer from "../common/PopupLayer";
import { getDeliveryLayerOptions } from "../../../app/Helper/DeliveryHelper";
import { getPopupURL } from "../../../app/Helper/CommonHelper";

/**
 * 배송정보 컴포넌트
 * - 해외 직배송, 구매대행
 * - 배송비
 * - 도착예정일
 * - 기타정보
 * - 묶음배송
 */
function DeliveryInfo() {
  const [isLayerOpen, setIsLayerOpen] = useState(false);
  const [isMtLayerOpen, setIsMtLayerOpen] = useState(false);
  const layerOptions = getDeliveryLayerOptions(
    TMON.oApp.htStorage.htStaticData
  );

  const handleLayerOpen = () => {
    if (TMON.oApp.sPlatform === "MA") {
      // data parameter 개선을 위해 localstorage 사용
      localStorage.setItem(
        "deal_popup_data",
        JSON.stringify({
          ...layerOptions,
          dealSrls: String(TMON.htStaticData.htDealInfo.dealNo),
        })
      );
      TMON.app.callApp(
        "webview",
        "showView",
        "배송정보",
        getPopupURL("delivery"),
        true
      );
    } else {
      setIsLayerOpen(true);
    }
  };

  const handleLayerClose = () => {
    setIsLayerOpen(false);
    setIsMtLayerOpen(false);
  };

  const handleMtLayerOpen = () => {
    setIsMtLayerOpen(true);
  };

  const handleMtLayerClose = () => {
    setIsMtLayerOpen(false);
  };

  const {
    bIsDeliveryDeal,
    htDealInfo: {
      deliveryInfo,
      isMartPartnerDeal,
    },
    sDealNo,
  } = TMON.htStaticData;

  const DeliveryOptionComponents = () => {
    return (
      <>
        <DeliveryOversea />
        <DeliveryFee />
        <DeliveryEstimatedDate />
        <DeliveryEtc />
      </>
    );
  };

  return (
    bIsDeliveryDeal &&
    deliveryInfo &&
    Object.keys(deliveryInfo).length > 1 && (
      <div className="deal_info_unit">
        <div className="info_unit_title">
          <h3 className="title">배송정보</h3>
        </div>
        <div className="info_unit_contents">
          {isMartPartnerDeal ? (
            <div>
              <DeliveryOptionComponents />
            </div>
          ) : (
            <div
              className="info_unit_button"
              role="button"
              onClick={handleLayerOpen}
              data-tlarea="DDDI"
              data-tldimension={`main_deal_srl:${sDealNo}`}
            >
              <DeliveryOptionComponents />
            </div>
          )}
          <DeliveryCombine />
          {/* 팝업 레이어 */}
          {isLayerOpen && (
            <PopupLayer
              title="배송정보"
              onClose={handleLayerClose}
              popupKey="delivery"
              layerOptions={{ ...layerOptions, mtLayerOpen: handleMtLayerOpen }}
            />
          )}
          {/* 제주/도서산간 검색 레이어는 PC일 때만 노출 */}
          {TMON.sDevice === "PW" && isMtLayerOpen && (
            <PopupLayer
              title="제주/도서산간 해당지역 보기"
              onClose={handleMtLayerClose}
              popupKey="mt_delivery"
            />
          )}
        </div>
      </div>
    )
  );
}

export default DeliveryInfo;
